import { render, staticRenderFns } from "./AdminItems.vue?vue&type=template&id=31333f7a"
import script from "./AdminItems.vue?vue&type=script&lang=js"
export * from "./AdminItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31333f7a')) {
      api.createRecord('31333f7a', component.options)
    } else {
      api.reload('31333f7a', component.options)
    }
    module.hot.accept("./AdminItems.vue?vue&type=template&id=31333f7a", function () {
      api.rerender('31333f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminItems.vue"
export default component.exports